<template>
  <div class="radio">
    <label class="question" :for="this._uid">{{ questionString }}</label>
    <div class="optionsWrapper">
      <label class="option" :for="`${this._uid}-false`"
        >{{
          getOptionText(option2Text, $mlGet("rmaTransport-default-option2"))
        }}
        <input
          type="radio"
          :id="`${this._uid}-false`"
          value="false"
          v-model="radioAnswer"
          :disabled="disabled"/>
        <span class="checkmark"></span
      ></label>

      <label
        :class="`option ${disabled && 'disabled'}`"
        :for="`${this._uid}-true`"
        >{{
          getOptionText(option1Text, $mlGet("rmaTransport-default-option1"))
        }}
        <input
          type="radio"
          :id="`${this._uid}-true`"
          value="true"
          v-model="radioAnswer"
          :disabled="disabled"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Radio extends Vue {
  @Prop() public questionString!: string;
  @Prop() public option1Text?: string;
  @Prop() public option2Text?: string;
  @Prop() public answer?: boolean;
  @Prop() public disabled?: boolean;
  public radioAnswer = "";

  @Watch("answer")
  onParrentChange(): void {
    this.radioAnswer = this.answer == true ? "true" : "false";
  }

  @Watch("radioAnswer")
  onPropertyChanged(value: string): void {
    this.$emit("userInput", value == "true" ? true : false);
  }

  getOptionText(option: string, fallback: string): string {
    return option ? option : fallback;
  }

  mounted(): void {
    this.onParrentChange();
  }
}
</script>

<style scoped>
.radio {
  padding: 5px 0px;
}

.optionsWrapper {
  padding-top: 1ex;
  display: flex;
  gap: 1em;
}

.disabled {
  color: #a0a0a0;
}

/* The container */
.option {
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 5px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.option input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.option:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.option input:checked ~ .checkmark {
  background-color: #da6f38;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.option input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.option .checkmark:after {
  top: 4px;
  left: 4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: white;
}
</style>
